var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpNarrow = function SvgArrowUpNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.94 8.06a1.5 1.5 0 0 1 0-2.12l4-4q.106-.107.23-.19l.031-.019q.108-.068.228-.117l.05-.019q.041-.016.086-.03a2 2 0 0 1 .144-.036c.192-.038.39-.038.583 0l.072.018q.036.008.07.018l.088.03.048.019q.12.05.228.117l.03.019q.126.082.233.19l4 4a1.5 1.5 0 0 1-2.121 2.12L13.5 6.62V21a1.5 1.5 0 0 1-3 0V6.62L9.06 8.06a1.5 1.5 0 0 1-2.12 0"
  })));
};
export default SvgArrowUpNarrow;